export default __webpack_public_path__ + "static/media/money3.a86696b7.jpg";